
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-lg flex items-center justify-center">
                <i className="ri-car-line text-xl text-black"></i>
              </div>
              <div>
                <div className="font-bold text-xl" style={{ fontFamily: '"Pacifico", serif' }}>
                  Georgia Dealer License
                </div>
                <div className="text-sm text-gray-400">Georgia Dealer License Experts</div>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Helping entrepreneurs successfully obtain their Georgia used car dealer license with our comprehensive step-by-step course and expert guidance.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover->yellow-500 transition-colors">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover->yellow-500 transition-colors">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover->yellow-500 transition-colors">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/course" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Course Overview
                </Link>
              </li>
              <li>
                <Link to="/consulting" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Book Consultation
                </Link>
              </li>
              <li>
                <Link to="/consulting" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Consulting Services
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Free Resources
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Support Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Support</h4>
            <ul className="space-y-2">
              <li>
                <a href="mailto:Info@gerogiadealerlicense.com" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Email Support
                </a>
              </li>
              <li>
                <a href="tel:+1-555-123-4567" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Phone Support
                </a>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Georgia Dealer License Course. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <span className="text-gray-400 text-sm">Powered by</span>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-yellow-400 hover:text-yellow-300 transition-colors text-sm font-medium"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
